import React from 'react'
import './BadgesRefundable.css'

function BadgesRefundable(props) {
  const {label, className} = props

  return (
    <div
      className={`badges-refundable txt-5--regular ${
        className ? className : ''
      }`}>
      <span className="text-ellipsis">{label}</span>
    </div>
  )
}

export default BadgesRefundable